import React from 'react';
import { useTranslate } from 'react-admin';

import Grid from '@material-ui/core/Grid';

import { TextField, AmountField } from '~/components';
import { l } from '~/resources/pricings/PricingShow';

const DefaultAmountLimitView = (props: { record: any }) => {
  const { record } = props;
  const translate = useTranslate();
  const t = (key: string, variant: number = 1): string => translate(l(`limits_.${key}`), variant);

  return (
    <Grid item container xs={12} spacing={2}>
      <Grid item xs={4}>
        <TextField label={t('amount')}>
          <AmountField amount={record.amount} />
        </TextField>
      </Grid>
    </Grid>
  );
};

export default DefaultAmountLimitView;
